import React from "react";

function ButtonTag({ width, backgroundcolor, name, icon, onClick, padding,fontSize }) {
  return (
    <button
      style={{
        width: width,
        padding: padding || "8px 20px",
        border: "1px solid #dAdAdA",
        borderRadius: "25px",
        backgroundColor: backgroundcolor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        color: "white",
        fontSize: fontSize || "14px",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {icon && React.cloneElement(icon, { sx: { fontSize: "18px"} })}
      {name}
    </button>
  );
}

export default ButtonTag;
